

import moment from "moment";
import duration from "moment-duration-format";



class MyDateTime {

    //מכניס תאריך וימים מהתאריך על מנת לקבל תאריך מתאים
    static getSpecificDate = (timeString, daysToAdd) => {

        let tm = moment(timeString).add(daysToAdd, 'days');

        return (
            tm.toString("dd/MM/yyyy 05:00")
        )
    }


    static getDateAndTime = (timeString) => {

        return (
            moment(timeString).utc(true).format('DD/MM/YYYY HH:mm:ss')
        )
    }
    static getDateAndTimeShort = (timeString) => {

        return (
            moment(timeString).utc(true).format('DD/MM/YYYY') + " " +moment(timeString).utc(true).format('HH:mm')
        )
    }

    //מכניס תאריך וימים מהתאריך על מנת לקבל תאריך מתאים
    static getFirstDayinMounth = (dateToSet) => {

        let tt = moment(dateToSet).set('date', 1);
        return (
            tt.toString("05:00 01/MM/yyyy")
        )
    }


    //מקבל אובייקט זמן ומסדר את השעה שלו לפי המבוקש
    //{ str: {hh,mm,ss}}
    static setTimeByStr(timeitm, str) {

        let theItm = moment(timeitm)
            .set('hour', str.hh || '00')
            .set('minute', str.mm || '00')
            .set('second', str.ss || '00');


        return theItm.toString("dd/MM/yyyy hh:mm:ss");
    }

    static getTimeAddMins = (timeString, MinToAdd) => {

        return (
            moment(timeString).add(MinToAdd, 'minutes').utc(true).format('DD/MM/YYYY HH:mm:ss')
        )
    }

    static getTimePastTilNow = (timeString) => {

        var seconds = moment().utc(true).diff(timeString, 'seconds')
        var duration = moment.duration(seconds, 'seconds');
        var formatted = duration.format("hh:mm:ss");

        return (
            formatted
        )
    }

    static getColorLineByTime = (timeString, thenTime) => {
        var thenTime = moment(timeString).add(parseInt(thenTime), 'minutes')
        var seconds = moment().utc(true).diff(thenTime, 'seconds')
        var duration = moment.duration(seconds, 'seconds');
        var formatted = duration.format("hh:mm:ss");
        if (formatted.toString().includes("-")) {
            return ("lightGray")
        }
        else {
            return ("red")
        }
    }

    static getTimeLeftBetweenTimes = (currentTime, targetTime) => {
        // Parse the target time into a moment object
        const thenTime = moment(targetTime);
        const nowTime = moment(currentTime);

        // בדיקת חוקיות התאריכים
        if (!thenTime.isValid() || !nowTime.isValid()) {
            console.error("Invalid date format:", { currentTime, targetTime });
            return {
                theTm: "Invalid date",
                theCol: "gray",
                theForCol: "white",
                theEnd: true
            };
        }

        // Calculate the difference in seconds between now and the target time
        const seconds = thenTime.diff(nowTime, 'seconds');

        // Create a moment duration object from the difference in seconds
        const duration = moment.duration(Math.abs(seconds), 'seconds');

        // Format the duration into "hh:mm:ss"
        const formatted = duration.format("hh:mm:ss");

        // Calculate the total hours difference and split it into days and remaining hours
        const temp = Math.abs(thenTime.diff(nowTime, 'hours')); // Absolute hours difference
        const daysOver = Math.floor(temp / 24); // Calculate full days
        const hoursLeft = temp % 24; // Remaining hours after full days

        // Format the output to include days and hours even for future dates
        const bk = daysOver > 0
            ? `\u202B${daysOver} ${daysOver === 1 ? "יום" : "ימים"} ${hoursLeft}:${formatted.split(':')[1]}:${formatted.split(':')[2]}\u202C`
            : `\u202B${formatted}\u202C`;




        // Check if the target time is in the future or the past
        if (seconds >= 0) {
            // Future time (positive difference)
            return {
                theTm: bk, // Time left with days and hours
                theCol: "lightGray", // Background color
                theForCol: "black", // Text color
                theEnd: false // Time has not yet passed
            };
        } else {
            // Past time (negative difference)
            return {
                theTm: bk, // Time passed with days and hours
                theCol: "red", // Background color
                theForCol: "white", // Text color
                theEnd: true // Time has passed
            };
        }
    };






    static getTimeLeftTilThen = (timeString, thenTime) => {

        var thenTime = moment(timeString).add(parseInt(thenTime), 'minutes');

        // Calculate the difference in seconds between the current time and thenTime
        var seconds = moment().utc().diff(thenTime, 'seconds');

        // Create a moment duration from the seconds
        var duration = moment.duration(seconds, 'seconds');

        // Format the duration as "hh:mm:ss"
        var formatted = duration.format("hh:mm:ss");

        // Calculate the total hours and then extract days and remaining hours
        var temp = moment().utc().diff(thenTime, 'hours');
        var daysOver = parseInt(temp / 24);
        var hoursLeft = parseInt(temp % 24);

        if (formatted.toString().includes("-")) {
            return (
                {
                    theTm: formatted.toString().replace("-", ""),
                    theCol: "lightGray",
                    theForCol: "black",
                    theEnd: false
                }
            )
        }
        else {
            let bk = (daysOver > 0) ? formatted + " - " + daysOver + " ימים " + hoursLeft + " שעות" : formatted
            return (
                {
                    theTm: bk,
                    theCol: "red",
                    theForCol: "white",
                    theEnd: true
                }
            )
        }

    }


    static getDate = (timeString) => {
        return (
            moment(timeString).local().format('DD/MM/YYYY')
        )
    }
    static getTime = (timeString) => {
        return (
            moment(timeString).local().format('HH:mm:ss')
        )
    }
    static getShortTime = (timeString) => {
        return (
            moment(timeString).local().format('HH:mm')
        )
    }
    static getDateAndTime = (timeString) => {

        return moment(timeString).local().format('DD/MM/YYYY HH:mm:ss');
    }
    static getShortDateAndTime = (timeString) => {

        return (
            moment(timeString).local().format('DD/MM/YYYY HH:mm')
        )
    }
    static getDayOfWeek = (timeString) => {

        return (
            moment(timeString).local().format('dddd')
        )
    }
    static getDayOfWeekHeb = (timeString) => {
        switch (moment(timeString).local().format('dddd')) {
            case "Sunday": return "ראשון";
            case "Monday": return "שני";
            case "Tuesday": return "שלישי";
            case "Wednesday": return "רביעי";
            case "Thursday": return "חמישי";
            case "Friday": return "שישי";
            case "Saturday": return "שבת";
            default: return "";
        }

    }

    static getDayOfWeekToHeb = (dayName) => {
        switch (dayName) {
            case "Sunday": return "ראשון";
            case "Monday": return "שני";
            case "Tuesday": return "שלישי";
            case "Wednesday": return "רביעי";
            case "Thursday": return "חמישי";
            case "Friday": return "שישי";
            case "Saturday": return "שבת";
            default: return "";
        }

    }

    static getDayOfWeekLettersHeb = (DayName) => {
        switch (DayName) {
            case "Sunday": return "א";
            case "Monday": return "ב";
            case "Tuesday": return "ג";
            case "Wednesday": return "ד";
            case "Thursday": return "ה";
            case "Friday": return "ו";
            case "Saturday": return "ש";
            default: return "";
        }

    }


    static getNextSaturday = (date) => {
        const dayOfWeek = date.getDay(); // קבלת היום בשבוע (0 - ראשון, 6 - שבת)
        const daysUntilSaturday = (6 - dayOfWeek + 7) % 7 || 7; // חישוב הימים שנותרו עד שבת
        const nextSaturday = new Date(date);
        nextSaturday.setDate(date.getDate() + daysUntilSaturday);
        return nextSaturday;
    };

    
    static getEndOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    };


}
export default MyDateTime;

